import { ConnectionSetting } from 'common/types/kraken-core/ConnectionSettings'
import { GatewaySetting } from 'common/types/kraken-core/GatewaySettings'
import { TradingPartner } from 'common/types/kraken-core/TradingPartner'
import { searchConnectionSettings } from 'services/kraken-core/connection_settings/connection_settings.service'
import { searchTradingPartner } from 'services/kraken-core/trading_partner/tradingPartner.service'
import { searchGatewaySettings } from 'services/kraken-core/gateway_settings/gateway_settings.service'

export const onSearchTradingPartners = async ({
  query,
}: {
  query: string
}): Promise<TradingPartner[]> => {
  const result = await searchTradingPartner({
    filters: [
      {
        property: 'name',
        value: query,
      },
    ],
    page_size: 100,
  })
  return result?.response?.data?.results
}

export const onSearchConnections = async ({
  query,
}: {
  query: string
}): Promise<ConnectionSetting[]> => {
  const params = { name: query }
  const result = await searchConnectionSettings({
    ...params,
    page_size: 100,
  })
  return result?.response?.data?.results
}

export const onSearchGateways = async ({ query }: { query: string }): Promise<GatewaySetting[]> => {
  const params = { name: query }
  const result = await searchGatewaySettings({
    ...params,
    page_size: 100,
  })
  return result?.response?.data?.results
}
